export function getItemsOnPage<T>(items: Array<T>, currentPage: number, perPage: number): Array<T> {
  return items.slice((currentPage - 1) * perPage, (currentPage - 1) * perPage + perPage);
}
